import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getIsPlaylistEditable } from 'utils/privileges';
import useUniqueId from 'hooks/useUniqueId';
import useModalQueryParam from 'hooks/useModalQueryParam';
import Box from 'components/Box';
import Flex from 'components/Flex';
import { Menu, MenuButton, MenuList, MenuItem } from 'components/Menu';
import Heading from 'components/Heading';
import SectionEditorModal from 'screens/SectionEditorModal';
import SectionDeleteConfirmation from 'screens/SectionDeleteConfirmation';
import UserGeneratedText from 'components/UserGeneratedText';
var CONTENT_MAX_WIDTH = 820;
function SectionBlock(_ref) {
  var section = _ref.section,
    playlist = _ref.playlist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var menuId = useUniqueId();
  var name = section.name,
    description = section.description;
  var _useModalQueryParam = useModalQueryParam("edit-section-".concat(section.id)),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasEditDialog = _useModalQueryParam2[0],
    toggleEditDialog = _useModalQueryParam2[1];
  var _useModalQueryParam3 = useModalQueryParam("delete-section-".concat(section.id)),
    _useModalQueryParam4 = _slicedToArray(_useModalQueryParam3, 2),
    hasDeleteConfirmation = _useModalQueryParam4[0],
    toggleDeleteConfirmation = _useModalQueryParam4[1];
  var hasMenu = getIsPlaylistEditable({
    playlist: playlist
  });
  return /*#__PURE__*/React.createElement(Box, {
    mb: "m"
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    maxWidth: CONTENT_MAX_WIDTH
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    id: titleId
  }, name)), hasMenu && /*#__PURE__*/React.createElement(Menu, {
    id: menuId,
    menuPlacement: "bottom"
  }, /*#__PURE__*/React.createElement(MenuButton, {
    variant: "transparent",
    size: "medium",
    icon: "tools",
    "aria-label": "".concat(t('actions'), " ").concat(name),
    mb: "-xxxs",
    ml: "xxxs"
  }), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    icon: "edit",
    onClick: toggleEditDialog
  }, t('actions_edit_section')), /*#__PURE__*/React.createElement(MenuItem, {
    icon: "trash",
    onClick: toggleDeleteConfirmation
  }, t('actions_delete_section'))), hasEditDialog && /*#__PURE__*/React.createElement(SectionEditorModal, {
    section: section,
    playlistId: playlist.id,
    onClose: toggleEditDialog
  }), hasDeleteConfirmation && /*#__PURE__*/React.createElement(SectionDeleteConfirmation, {
    section: section,
    playlistId: playlist.id,
    onClose: toggleDeleteConfirmation
  }))), description && /*#__PURE__*/React.createElement(Box, {
    maxWidth: CONTENT_MAX_WIDTH,
    mt: "xs",
    fontSize: ['s', 'm'],
    breakpoints: "xs",
    overflow: "wrap"
  }, /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: description
  })));
}
export default SectionBlock;